import type { Countdown } from "./countdown.types";

export function saveCountdown(
  countdowns: Countdown[],
  updated: Countdown,
): Countdown[] {
  const alreadyExists = countdowns.some(
    (countdown) => countdown.id === updated.id,
  );

  if (alreadyExists) {
    return countdowns
      .map((countdown) =>
        countdown.id === updated.id
          ? updated
          : countdown,
      )
      .sort(
        (first, second) =>
          new Date(first.eventAt).getTime() -
          new Date(second.eventAt).getTime(),
      );
  }

  return [...countdowns, updated].sort(
    (first, second) =>
      new Date(first.eventAt).getTime() -
      new Date(second.eventAt).getTime(),
  );
}

export function removeCountdown(
  countdowns: Countdown[],
  countdownId: string,
): Countdown[] {
  return countdowns.filter(
    (countdown) => countdown.id !== countdownId,
  );
}